import React, { useEffect } from 'react'
import SelectInput from '../inputs/select-input'

const PriceMatch = ({data, types, columns, onRemove, onChange, onTransform}) => {
  const conditions = [['= 0', 'equals to 0'], ['> 0', 'greater than 0']]

  const query = (params) => {
    return `${params.column} ${params.condition}`
  }

  useEffect(() => {
    if (!data.condition) {
      const defaultParam = {...data, condition: conditions[0][0], completed: true}
      const defaultQuery = query(defaultParam)
      onChange({...defaultParam, query: defaultQuery})
    }
  }, [data.column])

  const changeData = (params) => {
    const newData = {...data, ...params}
    onChange({...data, ...params, query: query(newData)})
  }

  return <div className='filter-row'>
    { !data.type && <span className='where'>Where</span> }
    { data.type && 
      <SelectInput
        name='type'
        options={types}
        value={data.type}
        onChange={e => changeData({type: e.target.value})}
      />      
    }
    <SelectInput
      name='column'
      options={columns}
      value={data.column}
      onChange={e => onTransform(e.target.value)}
    />
    <SelectInput
      name='condition'
      options={conditions}
      value={data.condition || conditions[0][0]}
      onChange={e => changeData({condition: e.target.value})}
    />
    <button className='remove' onClick={onRemove}><i className='fa fa-trash-o' /></button>
  </div>
}

export default PriceMatch
